var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoundDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H20C21.1 26 22 25.1 22 24V8C22 6.9 21.1 6 20 6H8C6.9 6 6 6.9 6 8V24C6 25.1 6.9 26 8 26ZM8 42H20C21.1 42 22 41.1 22 40V32C22 30.9 21.1 30 20 30H8C6.9 30 6 30.9 6 32V40C6 41.1 6.9 42 8 42ZM28 42H40C41.1 42 42 41.1 42 40V24C42 22.9 41.1 22 40 22H28C26.9 22 26 22.9 26 24V40C26 41.1 26.9 42 28 42ZM26 8V16C26 17.1 26.9 18 28 18H40C41.1 18 42 17.1 42 16V8C42 6.9 41.1 6 40 6H28C26.9 6 26 6.9 26 8Z",
    fill: "#F6F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundDashboard);
export default __webpack_public_path__ + "static/media/ic_round-dashboard.b74be58538f939e52fcbd7c916f64893.svg";
export { ForwardRef as ReactComponent };